var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{attrs:{"outlined":"","color":"pink","loading":_vm.issuing,"disabled":_vm.issuing},on:{"click":_vm.issueLibrarySubscription},scopedSlots:_vm._u([{key:"loader",fn:function(){return [_c('span',[_vm._v("Issuing subscription...")])]},proxy:true}])},[_vm._v(" Issue library subscription ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }